<template>
	<div>
		<RightPaneMemberListRow 
			v-bind:item="item"
			v-bind:isSelected="isSelected"
			v-bind:isLoginUser="isLoginUser"
			v-bind:mode="mode"
			v-bind:watchSlide="watchSlide"
			v-on:member-selected="onClickMemberSelected"
			v-on:show-member-info="onClickShowMemberInfo"
			v-on:member-list-row-slide="onMemberListRowSlide"
		/>
	</div>
</template>
<script>
import RightPaneMemberListRow from './RightPaneMemberListRow';
export default {
	name: 'RightPaneMemberListRowOuter',
	components: {
		RightPaneMemberListRow,
	},
	props: [
		'item',
		'isSelected',
		'isLoginUser',
		'mode',
		'watchSlide'
	],
	methods: {
		onClickShowMemberInfo: function(e) {
			this.$emit("show-member-info", e);
		},
		memberRowMoveStart: function(e) {
			this.$emit('member-row-move-start',e);
		},
		
		memberRowMoveEnd: function(e) {
			this.$emit('member-row-move-end',e);
		},
		onMemberListRowSlide: function(e) {
			this.$emit('member-list-row-slide',e);
		},
		InsertMemberRow: function(e){
			this.$emit('insert-member-row',e);
		},
		InsertMemberRowTop: function(e){
			this.$emit('insert-member-row-top',e);
		},
		onClickMemberSelected: function(e) {
			this.$emit('member-selected', e);
		},
	}
};
</script>
<style>
</style>
